<template>
  <div class="page-content">
    <b-row>
      <b-col md="10">
        <page-breadcrumb title="Product Management" class="mb-3" />
      </b-col>
    </b-row>
    <data-create-popup title="Create Group"
      :schema="create_schema" :default-data="default_data"
      :create-data-fn="createItem" @create="$refs.group_list.getList()"
    />
    <data-table-ssr id="group_list" ref="group_list"
      :columns="fields" :get-list-fn="getList"
      :to-edit-fn="toEditPage"
    />
  </div>
</template>

<script>
import service from "../service";
import default_data from "../default_data"
const create_schema = [
  {
    cols: 4,
    fields: [
      { label: 'Thumbnail', field: 'thumbnail', input_type: 'image', validate: { required: true } },
    ]
  },
  {
    cols: 8,
    fields: [
      { label: 'Name', field: 'name', input_type:'ui-component', validate: { required: true } },
      { label: 'Type', field: 'type', input_type: 'select', options: [{text: "GEM", value: 1}], validate: { required: true } },
      { label: 'Store id', field: 'store_id', validate: { required: true } },
      { label: 'Discount info', field: 'discount_info', input_type: 'text'},
      { label: 'Tag', field: 'tag', input_type: 'text'},
    ]
  }
];

const fields = [
  { label: 'Thumbnail', field: 'thumbnail', input_type: 'image' },
  { label: 'Name', field: 'name', display_type: 'translatable-text' },
  { label: 'Type', field: 'type', input_type: 'select', options: [{text: "GEM", value: 1}] },
  { label: 'Store Id', field: 'store_id' },
  { label: 'Discount info', field: 'discount_info' },
  { label: 'Tag', field: 'tag' },
  { label: 'Created At', field: 'insert_datetime', input_type: 'datetime' },
];
export default {

  data() {
    return {
      products: [],
      default_data: {...default_data},
      create_schema,
      fields,
      type_options: [{text: "GEM", value: 1}]
    };
  },

  created() {
  },

  methods: {
    async getList({ limit, page, query }) {
      let response_data = await service.getList({
        query: JSON.stringify({ ...query }),
        page, limit
      });
      let list = [], total = 0;
      if (response_data) {
        list = response_data.list;
        total = response_data.total;
        this.total = total;
      }
      return { list, total };
    },
    async createItem(data) {
      let new_item = await service.create({ ...data });
      return new_item;
    },
    toEditPage({ id }) {
      this.$router.push({ name: 'iap-product-detail', params: { id: id } });
    },
  },
};
</script>
